import React from 'react';
import { RouteComponentProps } from 'react-router';
import { useTranslation } from 'react-i18next';

interface Props extends RouteComponentProps<{ id: string }> {}

const Media: React.FC<Props> = ({ match }) => {
    const { t } = useTranslation();
    return (
        <div id="am_route_content" className="media">
            <h1>{t('nav.media')}</h1>
        </div>
    );
};

export default Media;
